/** sub_order_id → list/by-ids-without-name 행 (null = 조회 완료했으나 응답에 없음) */
export const subOrderListByIdsWithoutNameCache = new Map();

/** 정렬된 요청 id 집합 키 → 진행 중 Promise */
export const subOrderListByIdsWithoutNameInflight = new Map();

export function invalidateSubOrderListByIdsWithoutNameCache() {
  subOrderListByIdsWithoutNameCache.clear();
  subOrderListByIdsWithoutNameInflight.clear();
}
